import React, { Component } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import moment from 'moment';


class RegisterGrid extends Component {
    constructor(props) {
        super(props);
        const that = this;
        this.state = {
            columnDefs: [
                { field: 'id', headerName: "dataID", cellClass: 'non-number', width: 120, cellRenderer: 'agGroupCellRenderer', headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true },
                { field: 'name', headerName: 'Name', cellClass: 'non-number', width: 100, cellStyle: this.dataStatusColorCellStyle },
                { field: 'regulator', headerName: 'Regulator', cellClass: 'non-number', width: 100 },
                { field: 'license', headerName: 'License', cellClass: 'non-number', width: 100 },
                { field: 'licenseNo', headerName: 'License no', cellClass: 'non-number', width: 100 },
                { field: 'applicationStatus', headerName: 'Application Status ', cellClass: 'non-number', width: 200 },
                { field: 'licensingStatus', headerName: 'Licensing Status ', cellClass: 'non-number', width: 200 },
                { field: 'licensedDate', headerName: 'Licensed date', cellClass: 'non-number', width: 200 },
                { field: 'validTo', headerName: 'Valid to', cellClass: 'non-number', width: 200 },
                { field: 'examinationStatus', headerName: 'Examination Status', cellClass: 'non-number', width: 200 },
                { field: 'examinationDeadline', headerName: 'Examination Deadline', cellClass: 'non-number', width: 200 },
                { field: 'deregistrationDate', headerName: 'Deregistration Date', cellClass: 'non-number', width: 200 },

            ],
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 50,
                sortable: true,
                filter: true,
                resizable: true,
            },
            rowSelection: "multiple",
            context: { componentParent: this },
            rowClassRules: {

                'MarkBackgroundGreen': function (params) {
                    // if(params.data.status === 'New') {
                    return params.data.state === 'Accepted';
                    // } alertFlag  limitFlag  1 表示出警
                },

            },


            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: [
                        { field: 'id', headerName: 'id', cellClass: 'non-number', width: 120, cellRenderer: 'agGroupCellRenderer', headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true },
                        // {
                        //   field: 'questionnaireName',
                        //   headerName: "Questionnaire Name",
                        //   cellClass: 'non-number',
                        //   width: 200,
                        // },
                        {
                            field: 'questionNumber',
                            headerName: "Question Number",
                            cellClass: 'non-number',
                            width: 140,
                        },
                        {
                            field: 'subQuestionNumber',
                            headerName: "SubQuestion Number",
                            cellClass: 'non-number',
                            width: 160,
                        },
                        {
                            field: 'questionEnglish',
                            headerName: "Question English",
                            cellClass: 'non-number',
                            width: 300,
                        },
                        {
                            field: 'questionChinese',
                            headerName: "Question Chinese",
                            cellClass: 'non-number',
                            width: 300,
                        },
                        {
                            field: 'questionTypeLabel',
                            headerName: "Question Type",
                            cellClass: 'non-number',
                            width: 120,
                        },
                        // {
                        //   field: 'answeree',
                        //   headerName: "Answeree",
                        //   cellClass: 'non-number',
                        //   width: 150,
                        // },
                        {
                            field: 'answerContent',
                            headerName: "Answer Content",
                            cellClass: 'non-number',
                            width: 250,
                        },
                        // {
                        //     field: 'score',
                        //     headerName: "Score",
                        //     cellClass: 'non-number',
                        //     editable: function (params) {
                        //     return !(params.data.questionType === '1' || params.data.questionType === '2');
                        //     },
                        //     width: 120,
                        // },
                        {
                            field: 'correctAnswer',
                            headerName: "Correct Answer",
                            cellClass: 'non-number',
                            width: 250,
                        },
                        {
                            field: 'answerDateLabel',
                            headerName: "Answer Date",
                            cellClass: 'non-number',
                            width: 150,
                        },
                        // {headerName: 'action', cellClass: 'non-number', width: 100, cellRenderer: (node) => this.finishTaskOpenModalBtn(node, props)},
                    ],
                    suppressRowClickSelection: true,
                    suppressAggFuncInHeader: true,
                    defaultColDef: { sortable: true, resizable: true, filter: true },
                    animateRows: true,
                    immutableData: false,
                    onSelectionChanged(event) {
                        let rowNodeArray = event.api.getSelectedNodes();
                        let cptRcdDataArray = rowNodeArray.map(rowNode => rowNode.data);
                        that.props.selectRegisterTask(cptRcdDataArray);
                    },

                },
                getDetailRowData: function (params) {
                    params.successCallback(params.data.questionAnswerList);
                },
                getRowNodeId: function (data) {
                    return data.id;
                },
                template:
                    '<div style="height: 100%; background-color: #edf6ff; padding: 20px; box-sizing: border-box;">' +
                    '  <div style="height: 10%; margin-bottom: 10px; font-weight: bold;">Personal Info Form</div>' +
                    '  <div ref="eDetailGrid" style="height: 90%;"></div>' +
                    '</div>'
            },

            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
        }
    }


    dataStatusColorCellStyle(param) {
        const status = param.value;
        if (status === 'Working' || status === 'Finished') {
            return { color: 'green' };
        }
        return { color: 'black' };
    }


    finishTaskOpenModalBtn = (node, props) => {
        const retDiv = document.createElement('div');
        const data = node.data;
        if (data.status === 'Finished') {
            return retDiv;
        }
        const finishTaskBtn = document.createElement('button');
        const finishTaskText = document.createTextNode("FinishTask");
        finishTaskBtn.appendChild(finishTaskText);
        finishTaskBtn.onclick = () => {
            props.openFinishTaskModal(data);
        }
        retDiv.appendChild(finishTaskBtn);
        return retDiv;
    }


    getRowNodeId = data => {
        return data.id;
    };

    onDataSelectionChanged = (event) => {
        let rowNodeArray = event.api.getSelectedNodes();
        let registerArray = rowNodeArray.map(rowNode => rowNode.data);
        this.props.selectRegister(registerArray);
    }
    onDataSelectionTaskChanged = (event) => {
        let rowNodeArray = event.api.getSelectedNodes();
        let registerSubArray = rowNodeArray.map(rowNode => rowNode.data);
        this.props.selectRegisterTask(registerSubArray);
    }


    render() {
        const {
            loadRegisterInfoActionStatus,
            loadRegisterInfoResp,
        } = this.props;

        const isLoading = loadRegisterInfoActionStatus === ACTION_STATUS.LOGINING;
        let loadRegisterInfoArray = [];
        if (!!loadRegisterInfoResp && !!loadRegisterInfoResp.data) {
            loadRegisterInfoArray = loadRegisterInfoResp.data;
        }


        return (
            <div className={'ag-theme-balham grid-wrapper'}>
                {isLoading ? (
                    <Loader active content="Loading..." />
                ) : (
                    <AgGridReact
                        // properties
                        columnDefs={this.state.columnDefs}
                        rowData={loadRegisterInfoArray}
                        defaultColDef={this.state.defaultColDef}
                        rowSelection={this.state.rowSelection}
                        rowClassRules={this.state.rowClassRules}
                        suppressRowClickSelection={true}
                        suppressAggFuncInHeader={true}
                        animateRows={true}
                        immutableData={false}
                        enableRangeSelection={true}
                        getRowNodeId={this.getRowNodeId}
                        context={this.state.context}
                        statusBar={this.state.statusBar}
                        // master/detail
                        masterDetail={true}
                        detailCellRendererParams={this.state.detailCellRendererParams}
                        // event
                        onSelectionChanged={this.onDataSelectionChanged}
                        sideBar={true}
                        resizable={true}
                    />
                )}
            </div>
        );
    }

}

export default RegisterGrid;